import { createRouter, createWebHistory } from 'vue-router';
//import persistentData from '@/plugins/persistentData';
import Tracking from '@/views/Tracking.vue'

/* const guard = (to, from, next) => {
  if (persistentData.get('token') !== null) {
    next()
  } else {
    next('/login')
  }
} */

const routes = [
  {
    path: '/',
    name: 'HOME',
    redirect: "/tracking"
  },
  {
    path: '/tracking',
    name: 'TRACKING',
    component: Tracking,
  },
  {
    path: '/tracking/:trackNumber',
    name: 'TRACKING_NUMBER',
    component: Tracking,
  }
  
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior () { window.scrollTo(0, 0) }
});

export default router;
